// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: sans-serif;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

#page-404 * {
  transition: all 0.6s;
}

#page-404 {
  display: table;
  width: 100%;
  height: 100vh;
  text-align: center;
  color: #888;
}

#page-404 .fof {
  display: table-cell;
  vertical-align: middle;
}

#page-404 .fof h1 {
  font-size: 50px;
  display: inline-block;
  padding-right: 12px;
  animation: type 0.5s alternate infinite;
  font-family: "Lato", sans-serif;
}

@keyframes type {
  from {
    box-shadow: inset -3px 0px 0px #888;
  }
  to {
    box-shadow: inset -3px 0px 0px transparent;
  }
}


.checkmark-1 {
  stroke: #eaf5fb;
  transition: 0.3s;
  fill: none;
}

.checkmark-2 {
  fill: #eaf5fb;
  transition: 0.3s;
}

.checkmark-3 {
  stroke: none;
}

.checkmark-4 {
  fill: none;
}

textarea {
    width: 100vw;
    min-height: 100px;
    height: 30vh;
    padding: 10px;
    margin: 0
}

.slider {
  padding: 20px 30px;
}

.root {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.wrapper {
  flex-grow: 1;
  background: var( #e4e9f1);
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.wrapper-contain {
  flex-grow: 1;
  background: var( #e4e9f1);
  position: relative;
  overflow: hidden;
}

.wrapper-scroll {
  flex-grow: 1;
  position: relative;
  overflow: auto;
}

/* @font-face {
  font-family: Nexa-Regular;
  src: url('/assets/fonts/nexa/Nexa-Text-Regular.woff2') format('woff2');
}

@font-face {
  font-family: Nexa-Black;
  src: url('/assets/fonts/nexa/Nexa-Text-Black.woff2') format('woff2');
}

@font-face {
  font-family: Nexa-Heavy;
  src: url('/assets/fonts/nexa/Nexa-Text-Heavy.woff2') format('woff2');
}
 */
.mui-wrapper {
  font-family: 'Nexa-Regular';
  color: '#1D252D';
  font-weight: '400';
  font-size: '14px';
}

.secondary-color {
  background: var( #ffffff);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT;gCAC8B;EAC9B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,0CAA0C;EAC5C;AACF;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;EAcE;AACF;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\n#page-404 * {\n  transition: all 0.6s;\n}\n\n#page-404 {\n  display: table;\n  width: 100%;\n  height: 100vh;\n  text-align: center;\n  color: #888;\n}\n\n#page-404 .fof {\n  display: table-cell;\n  vertical-align: middle;\n}\n\n#page-404 .fof h1 {\n  font-size: 50px;\n  display: inline-block;\n  padding-right: 12px;\n  animation: type 0.5s alternate infinite;\n  font-family: \"Lato\", sans-serif;\n}\n\n@keyframes type {\n  from {\n    box-shadow: inset -3px 0px 0px #888;\n  }\n  to {\n    box-shadow: inset -3px 0px 0px transparent;\n  }\n}\n\n\n.checkmark-1 {\n  stroke: #eaf5fb;\n  transition: 0.3s;\n  fill: none;\n}\n\n.checkmark-2 {\n  fill: #eaf5fb;\n  transition: 0.3s;\n}\n\n.checkmark-3 {\n  stroke: none;\n}\n\n.checkmark-4 {\n  fill: none;\n}\n\ntextarea {\n    width: 100vw;\n    min-height: 100px;\n    height: 30vh;\n    padding: 10px;\n    margin: 0\n}\n\n.slider {\n  padding: 20px 30px;\n}\n\n.root {\n  display: flex;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.wrapper {\n  flex-grow: 1;\n  background: var( #e4e9f1);\n  position: relative;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrapper-contain {\n  flex-grow: 1;\n  background: var( #e4e9f1);\n  position: relative;\n  overflow: hidden;\n}\n\n.wrapper-scroll {\n  flex-grow: 1;\n  position: relative;\n  overflow: auto;\n}\n\n/* @font-face {\n  font-family: Nexa-Regular;\n  src: url('/assets/fonts/nexa/Nexa-Text-Regular.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: Nexa-Black;\n  src: url('/assets/fonts/nexa/Nexa-Text-Black.woff2') format('woff2');\n}\n\n@font-face {\n  font-family: Nexa-Heavy;\n  src: url('/assets/fonts/nexa/Nexa-Text-Heavy.woff2') format('woff2');\n}\n */\n.mui-wrapper {\n  font-family: 'Nexa-Regular';\n  color: '#1D252D';\n  font-weight: '400';\n  font-size: '14px';\n}\n\n.secondary-color {\n  background: var( #ffffff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
